/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import cn from 'clsx';
import { SearchOutlined } from '@ant-design/icons';
import T from 'i18n-react';
import { Input } from 'antd';
import classes from './SearchBox.module.scss';

const { Search } = Input;

const SearchBox = ({ className = '', placeholder = '', onSearch = () => {}, searchVal = '' }) => {
  const [val, setVal] = useState('');

  useEffect(() => {
    if (searchVal !== val) {
      setVal(searchVal);
    }
  }, [searchVal]);

  return (
    <div className={cn(classes.wrapper, className)}>
      <Search
        placeholder={placeholder}
        enterButton={T.translate('buttons.search')}
        size="large"
        prefix={
          <SearchOutlined
            style={{
              fontSize: 16,
              color: '#1677ff',
            }}
          />
        }
        value={val}
        onChange={(e) => {
          setVal(e.target.value);
        }}
        onSearch={(tValue) => {
          onSearch && onSearch(tValue);
        }}
      />
    </div>
  );
};

export default SearchBox;
